
<div :id="`user-group-select-${groupName}`" class="user-input-rde">
  <div class="ws-label-section">{{ groupName }}</div>
  <RadioGroup
    v-model="multiSelectType"
    :items="[
      {
        label: $t('workspace_rde.base.label.user'),
        value: 'user',
      },
      {
        label: $t('workspace_rde.rde_detail.label.group_user'),
        value: 'group',
      },
    ]"
    @input="handleTypeChange"
  />
  <v-autocomplete
    v-if="multiSelectType === 'user'"
    :id="`user-group-select-dropdown-${groupName}`"
    v-model="values[mapFields]"
    :items="final_user_items"
    outlined
    dense
    small-chips
    multiple
    clearable
    deletable-chips
    class="app-g-autocomplete-v2"
    :label="$t('workspace_rde.base.label.user')"
    :rules="[validateRequired]"
  />

  <v-autocomplete
    v-if="multiSelectType === 'group'"
    :id="`user-group-select-dropdown-${groupName}`"
    v-model="selectedUserGroups"
    :items="user_group_items"
    itemText="name"
    itemValue="members"
    outlined
    dense
    small-chips
    multiple
    clearable
    deletable-chips
    class="app-g-autocomplete-v2"
    :label="$t('workspace_rde.rde_detail.label.group_user')"
    :rules="[validateRequired]"
    @change="handleChangeGroup"
  />
</div>
